import React from "react";
import IconSpinner from "../Resources/svg/Icons/IconSpinner";

const SpinnerTable = ({title, subtitle}) => {
  return (
    <div className="loader-box">
      <IconSpinner className="loader-box" />
      <div className="loader-box__title">¡Danos un momento!</div>
      <div className="loader-box__parrafo">
        Se está cargando la información.
      </div>
    </div>
  );
};

export default SpinnerTable;
